import React, { FC } from 'react';
import { useTranslation } from '@blocs.i18n';
import { BodyText, ButtonAsWrapper, FlexRow } from '@minecraft.atoms';
import IconWithErrorBoundary from '@minecraft.icon';

type Props = {
  onSelect: () => void;
};

const AddCard: FC<Props> = ({ onSelect }) => {
  const { t } = useTranslation();

  return (
    <ButtonAsWrapper aria-label={t('common:billing.card.add')} role="button" onClick={onSelect}>
      <FlexRow
        justifyContent="center"
        alignItems="center"
        borderStyle="dotted"
        borderPlacement="all"
        borderRadius="lg"
        borderSize={0.1}
        borderColor="primary"
        className="cn_atom_px-12 cn_atom_py-8"
        gap="3"
      >
        <IconWithErrorBoundary name="add" themeColor="primary" />
        <BodyText fontWeight="semibold" color="link">
          {t('common:billing.card.add')}
        </BodyText>
      </FlexRow>
    </ButtonAsWrapper>
  );
};

export default AddCard;
